// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.spinner-background {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.065);
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
}

ion-card {
  margin: 20px 10px;
}
ion-card:first-child {
  margin: 10px 10px 20px;
}
ion-card .wrapper {
  width: 100%;
}
ion-card ion-card-header {
  padding: 0;
}
ion-card ion-card-header ion-card-title {
  display: flex;
  align-items: center;
  gap: 10px;
  -webkit-padding-start: 10px;
          padding-inline-start: 10px;
  justify-content: center;
}
ion-card ion-card-header ion-card-title .map-icon {
  font-size: 40px;
}
ion-card ion-card-header ion-card-title ion-label {
  font-size: 20px;
  flex-grow: 3;
  margin-bottom: 5px;
  word-break: break-word;
}
ion-card ion-card-header ion-card-subtitle {
  display: flex;
  font-size: 11px;
  align-items: center;
}
ion-card ion-card-header ion-card-subtitle .location-icon {
  margin-right: 2.5px;
}
ion-card ion-card-header ion-card-subtitle .favorite-icon {
  margin: 5px 0 0 auto;
  font-size: 24px;
  cursor: pointer;
}
ion-card ion-card-content {
  padding: 0px 8px 8px 0;
}
ion-card ion-card-content ion-chip {
  padding-inline: 10px;
  font-size: 12px;
}
ion-card ion-card-content ion-chip ion-icon {
  margin-right: 3.5px;
}
ion-card ion-item-options ion-item-option div {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
  font-size: 14px;
}
ion-card ion-item-options ion-item-option div ion-icon {
  font-size: 30px;
}

ion-popover.map-preview {
  --width: 300px;
  --min-height: 200px;
}

ion-popover.linked-resources {
  --max-height:250px;
  overflow-x: auto;
}
ion-popover.linked-resources ion-list {
  padding: 2px 5px;
}
ion-popover.linked-resources ion-list .linked-place-container {
  padding: 1px 5px;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 5px;
}
ion-popover.linked-resources ion-list .linked-place-container .displayName {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
}
ion-popover.linked-resources ion-list .availibility-shape {
  height: 8px;
  width: 8px;
  border-radius: 50%;
  margin-right: 3px;
}
ion-popover.linked-resources ion-list .place-type-icon {
  font-size: 20px;
  margin: 5px 5px 0 0;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/favorite-map-item/favorite-map-item.component.scss"],"names":[],"mappings":"AAyGA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAxGF;;AA2GA;EAIE,iBAAA;AA3GF;AAwGE;EACE,sBAAA;AAtGJ;AAyGE;EACE,WAAA;AAvGJ;AAyGE;EACE,UAAA;AAvGJ;AAwGI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,2BAAA;UAAA,0BAAA;EACA,uBAAA;AAtGN;AAuGM;EACE,eAAA;AArGR;AAuGM;EACE,eAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;AArGR;AAyGI;EACE,aAAA;EACA,eAAA;EACA,mBAAA;AAvGN;AAwGM;EACE,mBAAA;AAtGR;AAwGQ;EACE,oBAAA;EACA,eAAA;EACA,eAAA;AAtGV;AA0GE;EACE,sBAAA;AAxGJ;AAyGI;EACE,oBAAA;EACA,eAAA;AAvGN;AAwGM;EACE,mBAAA;AAtGR;AA4GQ;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;AA1GZ;AA2GY;EACI,eAAA;AAzGhB;;AAiHA;EACE,cAAA;EACA,mBAAA;AA9GF;;AAiHA;EACE,kBAAA;EACA,gBAAA;AA9GF;AA+GE;EACE,gBAAA;AA7GJ;AA8GI;EACE,gBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AA5GN;AA6GM;EACE,oBAAA;EACA,4BAAA;EACA,qBAAA;EACA,gBAAA;EACA,uBAAA;AA3GR;AA8GI;EACE,WAAA;EACA,UAAA;EACA,kBAAA;EACA,iBAAA;AA5GN;AA8GI;EACE,eAAA;EACA,mBAAA;AA5GN","sourcesContent":["// ion-icon {\n//     font-size: 45px;\n// }\n// .row-padding{\n//   padding-left: 2px;\n// }\n// .icon-favorite{\n//   font-size: 24px;\n//   margin-left: 10px;\n// }\n// ion-item {\n//   --inner-padding-end:0;\n// }\n\n// .filled {\n//   color: #E0061C;\n// }\n\n// .icon-capacity{\n//   font-size: 14px;\n// }\n\n// ion-list{\n//   padding-bottom: 0;\n// }\n// .map-displayName {\n//   overflow: hidden;\n//   display: -webkit-box;\n//   -webkit-line-clamp: 2;\n//   -webkit-box-orient: vertical;\n//   white-space: pre-wrap;\n//   margin-bottom: 10px;\n//   cursor: pointer;\n// }\n// .margin-right {\n//   margin-right: 16px;\n// }\n// ion-thumbnail {\n//   margin-right: 16px;\n// }\n// ion-badge {\n//   display: flex;\n//   align-items: center;\n//   justify-content: center;\n//   gap: 4px;\n//   font-size: 12px;\n//   font-weight: 400;\n//   flex: 1.5;\n// }\n\n// ion-searchbar {\n//   padding-inline: 5px;\n//   color: #92949C;\n//   background-color: white;\n// }\n\n// .location-item{\n//   display: flex;\n//   justify-content: center;\n// }\n\n// // .top-padding {\n// //   padding-top: 10px;\n// // }\n// .spinner-background {\n//   position: fixed;\n//   top: 0;\n//   left: 0;\n//   bottom: 0;\n//   right: 0;\n//   background: rgba(0, 0, 0, 0.15);\n//   z-index: 999;\n//   display: flex;\n//   align-items: center;\n//   justify-content: center;\n// }\n\n// .spinner-background-item {\n//   position: absolute;\n//   top: 0;\n//   left: 0;\n//   bottom: 0;\n//   right: 0;\n//   background: rgba(0, 0, 0, 0.15);\n//   z-index: 999;\n//   display: flex;\n//   align-items: center;\n//   justify-content: center;\n// }\n\n// @media (max-width:472px) {\n//   .icon-favorite{\n//     font-size: 20px;\n//     margin-left: 2px;\n//   }\n\n//     ion-badge{\n//         --padding-top:5px;\n//         font-size: 10px;\n//     }\n//   ion-button{\n//     font-size: 10px;\n//   }\n// }\n\n.spinner-background {\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background: rgba(0, 0, 0, 0.065);\n  z-index: 999;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\nion-card {\n  &:first-child {\n    margin: 10px 10px 20px;\n  }\n  margin: 20px 10px;\n  .wrapper {\n    width: 100%;\n  }\n  ion-card-header{\n    padding: 0;\n    ion-card-title {\n      display: flex;\n      align-items: center;\n      gap: 10px;\n      padding-inline-start: 10px;\n      justify-content: center;\n      .map-icon {\n        font-size: 40px;\n      }\n      ion-label {\n        font-size: 20px;\n        flex-grow: 3;\n        margin-bottom: 5px;\n        word-break: break-word;\n\n      }\n    }\n    ion-card-subtitle{\n      display: flex;\n      font-size: 11px;\n      align-items: center;\n      .location-icon {\n        margin-right: 2.5px;\n    }\n        .favorite-icon {\n          margin: 5px 0 0 auto;\n          font-size: 24px;\n          cursor: pointer;\n      }\n    }\n  }\n  ion-card-content{\n    padding: 0px 8px 8px 0;\n    ion-chip {\n      padding-inline:10px;\n      font-size: 12px;\n      ion-icon {\n        margin-right: 3.5px;\n      }\n    }\n  }\n  ion-item-options{\n    ion-item-option {\n        div {\n            display: flex;\n            flex-direction: column;\n            align-items: center;\n            gap: 5px;\n            font-size: 14px;\n            ion-icon {\n                font-size: 30px;\n            }\n        }\n    }\n  }\n}\n\n\nion-popover.map-preview {\n  --width: 300px;\n  --min-height: 200px;\n}\n\nion-popover.linked-resources {\n  --max-height:250px;\n  overflow-x: auto;\n  ion-list{\n    padding:2px 5px;\n    .linked-place-container {\n      padding: 1px 5px;\n      font-size: 14px;\n      display: flex; \n      align-items: center;\n      gap: 5px;\n      .displayName {\n        display: -webkit-box;\n        -webkit-box-orient: vertical;\n        -webkit-line-clamp: 2;     \n        overflow: hidden;\n        text-overflow: ellipsis;\n      }\n    }\n    .availibility-shape {\n      height: 8px;\n      width: 8px;\n      border-radius: 50%;\n      margin-right: 3px;\n    }\n    .place-type-icon {\n      font-size: 20px;\n      margin: 5px 5px 0 0;\n    }\n    \n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
